import type { Rubrica } from "@/types/rubricas/Rubrica";
import type { RubricaAnaliseLote } from "@/types/rubricas/analise-lote/RubricaAnaliseLote";
import type { ProcessamentoLoteAprovacaoRequest } from "@/types/rubricas/analise-lote/ProcessamentoLote";
import type { RubricaLoteFilters } from "@/services/ServiceRubricaLote";

/** O BFF exige Idempotency-Key; repetir a chave devolve o lote já criado em vez de duplicar. */
export function gerarChaveIdempotencia(): string {
  // randomUUID só existe em contexto seguro (https/localhost).
  return (
    globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(16).slice(2)}`
  );
}

/** `descricao` do lote = comentário da análise, registrado no histórico e na auditoria. */
export function descricaoLote(comentario: string): { descricao?: string } {
  const descricao = comentario.trim();
  return descricao ? { descricao } : {};
}

export function requisicaoAprovacao(
  rubricas: Rubrica[],
  comentario = "",
): ProcessamentoLoteAprovacaoRequest {
  return {
    acao: "APROVACAO",
    ...descricaoLote(comentario),
    selecao: {
      inclusoes: [{ tipo: "IDS", idsAnaliseRubrica: rubricas.map((r) => r.idAnaliseRubrica) }],
    },
    payload: { status: "ANALISADO" },
  };
}

/** Aprova o grupo inteiro com os filtros da aba; o BFF escolhe as rubricas no servidor. */
export function requisicaoAprovacaoGrupo(
  grupo: RubricaAnaliseLote["grupo"],
  baseFilters: RubricaLoteFilters,
): ProcessamentoLoteAprovacaoRequest {
  return {
    acao: "APROVACAO",
    selecao: { inclusoes: [{ tipo: "GRUPO", grupo, baseFilters, itemFilters: {} }] },
    payload: { status: "ANALISADO" },
  };
}

/** O que o modal de confirmação mostra: total, descrições e naturezas distintas. */
export interface ResumoAprovacao {
  total: number;
  descricoes: string[];
  naturezas: number[];
}

export function resumoAprovacao(rubricas: Rubrica[]): ResumoAprovacao {
  return {
    total: rubricas.length,
    descricoes: [...new Set(rubricas.map((rubrica) => rubrica.descricao ?? "—"))],
    naturezas: [...new Set(rubricas.flatMap((rubrica) => rubrica.naturezaCodigo ?? []))],
  };
}
